import { Check } from "@sparkware/app-utils";
import { IndicatorLayout } from "./indicator-layout";

export type IndicatorIconKey = "OMG" | "FreePlay" | "Challenges";
interface IndicatorIconBgPositionSet {
    listLayout?: string;
    active: string;
    default: string;
};
interface IndicatorIconBgPositionThemeSet {
    default: IndicatorIconBgPositionSet;
    casino777?: IndicatorIconBgPositionSet;
    harrahsAndWsop?: IndicatorIconBgPositionSet;
}
type IndicatorIconBgPositionObject = {
    [key in IndicatorIconKey]: IndicatorIconBgPositionThemeSet
};
const IndicatorIconBgPosition: IndicatorIconBgPositionObject = {
    OMG: {
        default: {
            listLayout: "-107px -238px",
            active: "-141px -233px",
            default: "-141px -276px"
        },
        casino777: {
            active: "-313px -469px",
            default: "-313px -430px"
        },
        harrahsAndWsop: {
            active: "-205px -358px",
            default: "-95px -358px"
        }
    },
    FreePlay: {
        default: {
            listLayout: "",
            active: "-39px -235px",
            default: "-39px -275px"
        },
        casino777: {
            active: "-366px -469px",
            default: "-366px -430px"
        },
        harrahsAndWsop: {
            active: "-155px -358px",
            default: "-45px -358px"
        }
    },
    Challenges: {
        default: {
            listLayout: "",
            default: "-73px -275px",
            active: "-73px -235px"
        }
    }
};
export function getBackgroundPosition(iconKey: IndicatorIconKey, themeKey: keyof IndicatorIconBgPositionThemeSet, displayLayout?: IndicatorLayout, active?: boolean) {
    const iconSet = IndicatorIconBgPosition[iconKey];
    const iconThemeSet = !Check.isNullOrUndefined(iconSet[themeKey]) ? iconSet[themeKey] : iconSet["default"];
    if (displayLayout === IndicatorLayout.List && !Check.isNullOrUndefined(iconThemeSet.listLayout)) {
        return iconThemeSet.listLayout;
    } else {
        return active ? iconThemeSet.active : iconThemeSet.default;
    }
}
